import { IS_FAILSAFE_SANCTION_CHECK_ENABLED } from "@constants/common";
import { fetchSanctionStatus } from "@services/index";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useAccount } from "wagmi";

const useSanction = () => {
  const { address } = useAccount();

  const { data } = useQuery({
    queryKey: ["sanctionStatus", address],
    queryFn: async () => {
      const response = await fetchSanctionStatus(address as string);
      return response;
    },
    enabled: !!address,
    staleTime: 60_000, // 60 seconds
    initialData: undefined,
  });

  const isSanctioned = useMemo(() => {
    if (!data) {
      return false;
    }

    const riskScore =
      data.data?.data?.risk_assessment?.risk_score !== undefined
        ? data.data.data.risk_assessment.risk_score
        : 0;

    if (IS_FAILSAFE_SANCTION_CHECK_ENABLED) {
      return riskScore >= 80;
    }

    return data.isSanctioned;
  }, [data]);

  return { isSanctioned };
};

export default useSanction;
